import { render } from "./FooterBar.vue?vue&type=template&id=c9536e4c&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=c9536e4c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/motokandemir-web/motokandemir-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9536e4c"]])

export default __exports__